export default "__VITE_ASSET__B27togkj__"